import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-global-country-flag',
  templateUrl: './global-country-flag.component.html',
  styleUrls: ['./global-country-flag.component.css']
})
export class GlobalCountryFlagComponent implements OnInit, OnChanges {

  @Input() countryCode: string;
  @Input() flagUrl: string;
  @Input() countryName: string = 'Unknown';

  _src: string = 'assets/flags/unknown.png';

  private _usingLocal: boolean = false;
  private _usingExternal: boolean = false;

  constructor() { }

  ngOnInit() {
    this.updateSrc();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryCode'] || changes['flagUrl']) {
      this.updateSrc();
    }
  }

  private updateSrc() {
    this._usingLocal = false;
    this._usingExternal = false;

    if (this.countryCode) {
      this._src = `assets/flags/${this.countryCode.toLowerCase()}.png`;
      this._usingLocal = true;
    } else if (this.flagUrl) {
      this._src = this.flagUrl;
      this._usingExternal = true;
    } else {
      this._src = 'assets/flags/unknown.png';
    }
  }

  handleError() {
    if (this._usingLocal && this.flagUrl && !this._usingExternal) {
      // Fallback from local to external
      this._src = this.flagUrl;
      this._usingLocal = false;
      this._usingExternal = true;
    } else if (this._src !== 'assets/flags/unknown.png') {
      // Fallback to unknown
      this._src = 'assets/flags/unknown.png';
      this._usingExternal = false;
      this._usingLocal = false;
    }
  }

}
